import ContentLoader from 'react-content-loader';

type GraphSkeletonProps = {
  viewBox?: string;
};

export const GraphSkeleton = ({ viewBox }: GraphSkeletonProps) => (
  <div className="bg-gray-900 p-6 rounded-lg w-full h-full flex items-center justify-center">
    <ContentLoader
      speed={2}
      width="100%"
      height="100%"
      viewBox={viewBox ?? '0 0 400 280'}
      backgroundColor="#2d3748"
      foregroundColor="#4a5568"
      preserveAspectRatio="none"
    >
      {/* Chart Title */}
      <rect x="10%" y="5%" rx="4" ry="4" width="50%" height="8%" />
      {/* Y-Axis Labels */}
      <rect x="5%" y="25%" rx="4" ry="4" width="8%" height="5%" />
      <rect x="5%" y="50%" rx="4" ry="4" width="8%" height="5%" />
      <rect x="5%" y="75%" rx="4" ry="4" width="8%" height="5%" />
      {/* X-Axis Labels */}
      <rect x="25%" y="90%" rx="4" ry="4" width="20%" height="5%" />
      <rect x="65%" y="90%" rx="4" ry="4" width="20%" height="5%" />
      {/* X-Axis Line */}
      <rect x="15%" y="85%" rx="2" ry="2" width="70%" height="2%" />
      {/* Bars */}
      <rect x="30%" y="60%" rx="4" ry="4" width="15%" height="25%" />
      <rect x="70%" y="40%" rx="4" ry="4" width="15%" height="45%" />
    </ContentLoader>
  </div>
);
